export const getZoomLevel = (meter: number) => {
  const LEVELS: {[key: number]: number} = {
    5: 21,
    10: 20,
    20: 19,
    30: 18,
    50: 17,
    100: 16,
    300: 15,
    500: 14,
    1000: 13,
    3_000: 12,
    5_000: 11,
    10_000: 10,
    20_000: 9,
    30_000: 8,
    50_000: 7,
    100_000: 6,
  };

  if (LEVELS[meter]) {
    return LEVELS[meter];
  }

  const meters = Object.keys(LEVELS).map((i) => Number(i));
  const closest = meters.reduce(
    (acc, cur) => (Math.abs(cur - meter) < Math.abs(acc - meter) ? cur : acc),
    meters[0]
  );

  return LEVELS[closest];
};
